import { PrestacionPreparacion } from "../domain/entities/prestaciónPreparación";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetPrestacionPreparacion {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(
    idPrestación: number,
    token: string
  ): Promise<PrestacionPreparacion[]> {
    const colPrestaciones: PrestacionPreparacion[] =
      await this.protocoloService.getPrestacionPreparacion(idPrestación, token);
    return colPrestaciones;
  }
}
